import * as d3 from 'd3'
export default {
  methods: {

    draw_Header() {
      

      let table = this.canvasForm
      .append('g')
      .attr('transform', `translate(15, 20)`)

      table
      .append('text')
      .attr('transform', `translate(0, 0)`)
      .attr('font-size', 13).attr('fill', '#000')
      .text(this.sql1.MAIN)

      table
      .append('text')
      .attr('transform', `translate(0, 13)`)
      .attr('font-size', 11).attr('fill', '#757575')
      .text(this.sql1.SUB)



      // Header
      let head = table
      .append('g')
      .attr('transform', `translate(0, 20)`)

      this.columns.forEach(d=> {
        head
        .append('text')
        .attr('transform', `translate(${d.mx}, ${16.5 + 10*0.35})`)
        .attr('font-size', 10).attr('fill', '#000')
        .attr('text-anchor', 'middle')
        .text(d.name)
      })
      this.gmx_Line(head, 0, this.table.width, 6,  6,  '#bcbcbc', 1, 1)
      this.gmx_Line(head, 0, this.table.width, 27, 27, '#bcbcbc', 1, 1)



    },


  }
}